import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  TextField,
  Button,
  Container,
  Paper,
  MenuItem,
  DialogActions,
  Grid,
  Box,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { useCreateUser, useGetOrganizations } from "..";
import { useAuthUser } from "react-auth-kit";

const validationSchema = yup.object({
  username: yup.string().required("Username non puo essere vuoto"),
  email: yup
    .string()
    .email("Inserisci un indirizzo mail valido")
    .required("Email non puo essere vuoto"),
  mobile: yup.string(),
  first_name: yup.string().required("Nome non puo essere vuoto"),
  last_name: yup.string().required("Cognome non puo essere vuoto"),
  org_id: yup.number().nullable(),
});

function CreateUser({ closeModal }) {
  const addUserMutation = useCreateUser(closeModal);
  const organizationsQuery = useGetOrganizations();
  const authUser = useAuthUser();

  const formik = useFormik({
    initialValues: {
      username: "",
      email: "",
      mobile: "",
      first_name: "",
      last_name: "",
      user_type: null,
      // if backend user, same org_id as themselves
      org_id: authUser().role == 2 ? authUser().user.org_id : null,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      addUserMutation.mutate({ ...values });
    },
  });

  return (
    <>
      <DialogTitle>Aggiungi utente backend</DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid container>
            <Grid item xs={6}>
              <Box sx={{ margin: "2vmin" }}>
                <TextField
                  id="first_name"
                  name="first_name"
                  label="First Name"
                  fullWidth
                  margin="dense"
                  variant="standard"
                  type="text"
                  value={formik.values.first_name}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.first_name &&
                    Boolean(formik.errors.first_name)
                  }
                  helperText={
                    formik.touched.first_name && formik.errors.first_name
                  }
                />
                <TextField
                  id="last_name"
                  name="last_name"
                  label="Last Name"
                  fullWidth
                  margin="dense"
                  variant="standard"
                  type="text"
                  value={formik.values.last_name}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.last_name && Boolean(formik.errors.last_name)
                  }
                  helperText={
                    formik.touched.last_name && formik.errors.last_name
                  }
                />
                <TextField
                  id="username"
                  name="username"
                  label="Username"
                  fullWidth
                  margin="dense"
                  variant="standard"
                  type="text"
                  value={formik.values.username}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.username && Boolean(formik.errors.username)
                  }
                  helperText={formik.touched.username && formik.errors.username}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ margin: "2vmin" }}>
                <TextField
                  id="email"
                  name="email"
                  label="Email"
                  fullWidth
                  margin="dense"
                  variant="standard"
                  type="text"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
                <TextField
                  id="mobile"
                  name="mobile"
                  label="Mobile"
                  fullWidth
                  margin="dense"
                  variant="standard"
                  type="text"
                  value={formik.values.mobile}
                  onChange={formik.handleChange}
                  error={formik.touched.mobile && Boolean(formik.errors.mobile)}
                  helperText={formik.touched.mobile && formik.errors.mobile}
                />

                {authUser().role === 1 && organizationsQuery.isSuccess && (
                  <TextField
                    label="Org ID"
                    name="org_id"
                    fullWidth
                    margin="dense"
                    variant="standard"
                    select
                    type="text"
                    value={formik.values.org_id}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.org_id && Boolean(formik.errors.org_id)
                    }
                    helperText={formik.touched.org_id && formik.errors.org_id}
                  >
                    {organizationsQuery.data.organizations.map((org) => (
                      <MenuItem key={org.id} value={org.id}>
                        {org.name}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              </Box>
            </Grid>
          </Grid>
          <Container sx={{ padding: "1vmin" }}>
            <DialogActions>
              <Button type="submit">Conferma</Button>
              <Button onClick={formik.handleReset} color="error">
                Reset
              </Button>
              <Button onClick={closeModal} color="error">
                Chiudi
              </Button>
            </DialogActions>
          </Container>
        </form>
      </DialogContent>
    </>
  );
}

export default CreateUser;
